import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_visual_safety_management_features_such_as_indicators'

export const dataPointDefinition = {
  retracedId: 'no_visual_safety_management_features_such_as_indicators',
  name: 'No visual safety management features such as indicators, convex mirrors in dead ends, reflectors, etc., to ensure safe d',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-bui-68x',
      number: 'HS-BUI-18-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-60',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-15,Yes',
      machineShowHide: '[2],hs-15,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-68x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29940,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
